import { createContext } from 'react'
import { RootType } from '../store'

export const StoreContext = createContext<RootType | null>(null)
